var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3333",
    "data-name": "Group 3333",
    transform: "translate(-1354 -182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12240",
    "data-name": "Path 12240",
    d: "M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z",
    transform: "translate(1354 182)",
    fill: "#26a4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "noun-delet-4151532",
    d: "M141.662,65.844a2.216,2.216,0,0,0,2.216,2.216h5.541a2.216,2.216,0,0,0,2.216-2.216V56.978h1.108a.554.554,0,1,0,0-1.108h-2.82a3.324,3.324,0,0,0-6.549,0h-2.82a.554.554,0,1,0,0,1.108h1.108Zm4.987-11.635a2.216,2.216,0,0,1,2.144,1.662H144.5a2.216,2.216,0,0,1,2.144-1.662Zm-2.77,2.77h6.649v8.865a1.108,1.108,0,0,1-1.108,1.108h-5.541a1.108,1.108,0,0,1-1.108-1.108V56.978Zm.554,7.757V59.195a.554.554,0,1,1,1.108,0v5.541a.554.554,0,1,1-1.108,0Zm3.324,0V59.195a.554.554,0,0,1,1.108,0v5.541a.554.554,0,1,1-1.108,0Z",
    transform: "translate(1222.351 136.41)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteicon);
export default __webpack_public_path__ + "static/media/deleteicon.c955f234bb12bbc725525451d2413939.svg";
export { ForwardRef as ReactComponent };